const pct = (n, of) => (of ? `${Math.round((n / of) * 1000) / 10}%` : "–");
const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");

// Share of visitors (per channel) who went on to sign up, and who are active members (not paused or declined).
export const Conversions = ({ rows = [] }) => (
  <div data-testid="visitors-conversions">
    <h3 className="text-lg">Sign-up conversion by share channel</h3>
    <p className="mb-3 text-xs text-slate-500">A sign-up counts when someone joins on the same day, on the same device, as their first visit. Active means the account is not paused or declined.</p>
    {!rows.length ? <p className="text-sm text-slate-400">No data yet.</p> : (
      <div className="overflow-x-auto">
        <table className="w-full text-xs sm:text-sm">
          <thead><tr className="border-b text-left text-xs text-slate-500">
            <th className="py-2 font-medium">Channel</th><th className="py-2 text-right font-medium">Visitors</th>
            <th className="py-2 text-right font-medium"><span className="sm:hidden">Sign-ups</span><span className="hidden sm:inline">Signed up</span></th><th className="py-2 text-right font-medium">Active</th>
          </tr></thead>
          <tbody>{rows.map((r) => (
            <tr key={r.name} className="border-b border-slate-100 last:border-0" data-testid={`conversion-row-${slug(r.name)}`}>
              <td className="py-2">{r.name}</td>
              <td className="py-2 text-right tabular-nums" data-testid={`conversion-visitors-${slug(r.name)}`}>{r.visitors}</td>
              <td className="py-2 text-right tabular-nums" data-testid={`conversion-requests-${slug(r.name)}`}>{r.requests} <span className="text-slate-400">({pct(r.requests, r.visitors)})</span></td>
              <td className="py-2 text-right tabular-nums" data-testid={`conversion-approved-${slug(r.name)}`}>{r.approved} <span className="text-slate-400">({pct(r.approved, r.visitors)})</span></td>
            </tr>))}</tbody>
        </table>
      </div>)}
  </div>
);
